/**
 * Что здесь не так:
 * Если таких слайдеров будет на странице несколько, то события будут пересекаться
 * todo: fix
 */

export {};

const arrow = 'arrow-v3';
const strategySliderSelector = '.js-strategy-slider';
const arrowPrev = `<button type="button" class="strategy-slider__arrow strategy-slider__arrow--prev"><svg class="svg-symbol svg-symbol--${arrow} svg-symbol--${arrow}-left"><use xlink:href="#svg-symbol--${arrow}-left"/></svg></button>`;
const arrowNext = `<button type="button" class="strategy-slider__arrow strategy-slider__arrow--next"><svg class="svg-symbol svg-symbol--${arrow} svg-symbol--${arrow}-right"><use xlink:href="#svg-symbol--${arrow}-right"/></svg></button>`;

$(strategySliderSelectorInit);

NLMK.strategySliderSelectorInit = strategySliderSelectorInit;

function strategySliderSelectorInit() {
    const changeTabs = function() {
        const tabIndex = $(strategySliderSelector)
            .find('.slick-current')
            .find('.strategy-slider__slide')
            .data('tabnumber');

        $('.strategy-action__content')
            .find('[data-tabnumber="' + tabIndex + '"]')
            .css({
                height: 'auto',
                visibility: 'visible',
                overflow: 'visible',
            })
            .addClass('active animated')
            .siblings()
            .css({
                height: '0',
                visibility: 'hidden',
                overflow: 'hidden',
            })
            .removeClass('active animated');
    };

    const $tabText = $(strategySliderSelector).find('.strategy-slider__text');

    const tabsText = function() {
        $tabText.each((index, el) => {
            const $el = $(el);
            const $tabTextInner = $el.find('span');
            $el.css({ width: 'auto' });

            $el.css({
                width: $tabTextInner.innerWidth() + 1,
            });
        });
    };

    const calculateSlideHeight = function($container) {
        const $slides = $container.find('.strategy-slider__text');
        let minHeight = 0;

        $slides.css({
            minHeight: 'auto',
        });
        if (!window.matchMedia('(min-width: 768px)').matches) {
            return;
        }

        $slides.each(function() {
            const $slide = $(this);
            const slideHeight = $slide.height();
            minHeight = slideHeight > minHeight ? slideHeight : minHeight;
        });

        $slides.css({
            minHeight: minHeight + 'px',
        });
    };

    $(strategySliderSelector)
        .on('init', function() {
            $('.strategy-slider__nav').css('visibility', 'visible');
            tabsText();
            calculateSlideHeight($(this));

            setTimeout(() => {
                $(strategySliderSelector).removeClass('no-accessible'); // TODO: fix accesble slide
            }, 2000);
            $(window).resize(() => {
                setTimeout(() => calculateSlideHeight($(this)), 100);
            });
        })
        .each(function() {
            const $self = $(this);
            const infinite = $self.data('infinite');

            $self.slick({
                dots: false,
                arrows: true,
                infinite: typeof infinite !== 'undefined' && !!infinite,
                slidesToShow: 4,
                prevArrow: arrowPrev,
                nextArrow: arrowNext,
                appendArrows: '.strategy-slider__nav',
                focusOnSelect: true,
                responsive: [
                    {
                        breakpoint: 1399,
                        settings: {
                            slidesToShow: 3,
                        },
                    },
                    {
                        breakpoint: 767,
                        settings: {
                            slidesToShow: 1,
                        },
                    },
                ],
            });

            $('.strategy-slider__arrow--prev').on('click', function() {
                $(strategySliderSelector).slick('slickPrev');
            });

            $('.strategy-slider__arrow--next').on('click', function() {
                $(strategySliderSelector).slick('slickNext');
            });

            changeTabs();

            $(strategySliderSelector).on('afterChange', function() {
                changeTabs();
            });
        });

    $(window).resize(() => {
        setTimeout(() => tabsText(), 90);
    });
}



// WEBPACK FOOTER //
// ./js/main/module/sliders/strategy.js